module.exports = __webpack_public_path__ + "static/media/Format_Application_IIITL.8ce24f4b.docx";